import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  snackbarStyleViaContentProps: {
    background: theme.palette.warning.main,
  },
}))

export default styles
